// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ChessAlpha.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./ChessMerida.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./ChessBerlin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./NotoSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./CAChess-min.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./CAChess-fig.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/board/blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/board/brown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/board/zeit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/board/informator.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/board/sportverlag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/board/beyer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/board/falken.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/board/green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/chesspieces/merida/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/chesspieces/merida/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/chesspieces/merida/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/chesspieces/merida/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/chesspieces/merida/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/chesspieces/merida/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/chesspieces/merida/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/chesspieces/merida/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/chesspieces/merida/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/chesspieces/merida/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/chesspieces/merida/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/chesspieces/merida/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/chesspieces/wikipedia/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/chesspieces/wikipedia/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/chesspieces/wikipedia/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/chesspieces/wikipedia/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/chesspieces/wikipedia/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/chesspieces/wikipedia/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/chesspieces/wikipedia/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/chesspieces/wikipedia/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/chesspieces/wikipedia/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/chesspieces/wikipedia/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../img/chesspieces/wikipedia/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../img/chesspieces/wikipedia/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../img/chesspieces/alpha/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../img/chesspieces/alpha/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../img/chesspieces/alpha/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../img/chesspieces/alpha/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../img/chesspieces/alpha/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../img/chesspieces/alpha/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../img/chesspieces/alpha/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../img/chesspieces/alpha/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../img/chesspieces/alpha/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../img/chesspieces/alpha/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../img/chesspieces/alpha/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../img/chesspieces/alpha/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../img/chesspieces/beyer/wP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../img/chesspieces/beyer/wB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../img/chesspieces/beyer/wN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../img/chesspieces/beyer/wR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../img/chesspieces/beyer/wQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../img/chesspieces/beyer/wK.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../img/chesspieces/beyer/bP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../img/chesspieces/beyer/bB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../img/chesspieces/beyer/bN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../img/chesspieces/beyer/bR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../img/chesspieces/beyer/bQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../img/chesspieces/beyer/bK.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../img/chesspieces/case/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../img/chesspieces/case/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../img/chesspieces/case/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../img/chesspieces/case/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../img/chesspieces/case/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../img/chesspieces/case/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../img/chesspieces/case/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../img/chesspieces/case/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../img/chesspieces/case/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../img/chesspieces/case/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../img/chesspieces/case/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../img/chesspieces/case/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../img/chesspieces/condal/wP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("../img/chesspieces/condal/wB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("../img/chesspieces/condal/wN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("../img/chesspieces/condal/wR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("../img/chesspieces/condal/wQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("../img/chesspieces/condal/wK.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("../img/chesspieces/condal/bP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("../img/chesspieces/condal/bB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("../img/chesspieces/condal/bN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("../img/chesspieces/condal/bR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("../img/chesspieces/condal/bQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("../img/chesspieces/condal/bK.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("../img/chesspieces/leipzig/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("../img/chesspieces/leipzig/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("../img/chesspieces/leipzig/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("../img/chesspieces/leipzig/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("../img/chesspieces/leipzig/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("../img/chesspieces/leipzig/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("../img/chesspieces/leipzig/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("../img/chesspieces/leipzig/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("../img/chesspieces/leipzig/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("../img/chesspieces/leipzig/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("../img/chesspieces/leipzig/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("../img/chesspieces/leipzig/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("../img/chesspieces/maya/wP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("../img/chesspieces/maya/wB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("../img/chesspieces/maya/wN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("../img/chesspieces/maya/wR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("../img/chesspieces/maya/wQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("../img/chesspieces/maya/wK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("../img/chesspieces/maya/bP.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("../img/chesspieces/maya/bB.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("../img/chesspieces/maya/bN.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("../img/chesspieces/maya/bR.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("../img/chesspieces/maya/bQ.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("../img/chesspieces/maya/bK.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("../img/chesspieces/uscf/wP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("../img/chesspieces/uscf/wB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("../img/chesspieces/uscf/wN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("../img/chesspieces/uscf/wR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("../img/chesspieces/uscf/wQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("../img/chesspieces/uscf/wK.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("../img/chesspieces/uscf/bP.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_117___ = new URL("../img/chesspieces/uscf/bB.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_118___ = new URL("../img/chesspieces/uscf/bN.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_119___ = new URL("../img/chesspieces/uscf/bR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_120___ = new URL("../img/chesspieces/uscf/bQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_121___ = new URL("../img/chesspieces/uscf/bK.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
var ___CSS_LOADER_URL_REPLACEMENT_117___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_117___);
var ___CSS_LOADER_URL_REPLACEMENT_118___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_118___);
var ___CSS_LOADER_URL_REPLACEMENT_119___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_119___);
var ___CSS_LOADER_URL_REPLACEMENT_120___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_120___);
var ___CSS_LOADER_URL_REPLACEMENT_121___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_121___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Alpha;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}
@font-face {
  font-family: Merida;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
@font-face {
  font-family: Berlin;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}
@font-face {
  font-family: NotoSans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
@font-face {
  font-family: "CAChess";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
}
@font-face {
  font-family: "CAChessFig";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

move fig.figurine {
  font-family: Alpha;
}
move fig.figurine.merida {
  font-family: Merida;
}
move fig.figurine.berlin {
  font-family: Berlin;
}
move fig.figurine.noto {
  font-family: NotoSans;
}
move fig.figurine.cachess {
  font-family: CAChessFig;
}

move san nag {
  font-family: CAChess;
}

/* Don't show diagram nags in the notation. */
.pgnvjs .moves move  nag[data-value="\$220"]::before {
  content: "";
}

.pgnvjs .moves move  nag[data-value="\$221"]::before {
  content: "";
}

/* CA Chess Font symbols */
.pgnvjs .moves move  nag[data-value="\$246"]::before {
  content: "\\00A8";
}

.pgnvjs .moves move  nag[data-value="\$247"]::before {
  content: "\\00AE";
}

.pgnvjs .moves move  nag[data-value="\$248"]::before {
  content: "\\00AF";
}

.pgnvjs .moves move  nag[data-value="\$252"]::before {
  content: "\\045B";
}

.pgnvjs .moves move  nag[data-value="\$254"]::before {
  content: "\\00AA";
}

.pgnvjs .moves move  nag[data-value="\$255"]::before {
  content: "\\0454";
}

/* Additional CA Chess Font symbols (drawn myself) */
.pgnvjs .moves move  nag[data-value="\$251"]::before {
  content: "\\00DE";
}

.pgnvjs .moves move  nag[data-value="\$249"]::before {
  content: "\\00DF";
}

.pgnvjs .moves move  nag[data-value="\$250"]::before {
  content: "\\00E0";
}

.pgnvjs .moves move  nag[data-value="\$253"]::before {
  content: "\\00E1";
}
.pgnvjs .moves move  nag[data-value="\$254"]::before {
  content: "\\00AA";
}
.pgnvjs .moves move  nag[data-value="\$255"]::before {
  content: "\\00BA";
}



/*
 * Board
 */
.blue cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.brown cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.zeit cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.informator cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.sportverlag cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.beyer cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.falken cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.green cg-board {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

/* SWAL buttons */
.modaly-wrapper {
  top: unset;
  left: unset;
}
.swalpgnvroot {
  z-index: 1060;
}
.swalpgnv {
  display: block;
  width: 44px;
  height: 44px;
  background-size: 40px;
}
.swalpgnv.queen {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.swalpgnv.rook {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.swalpgnv.bishop {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.swalpgnv.knight {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.swalpgnv.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.swalpgnv.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.swalpgnv.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.swalpgnv.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
/*
 * Merida
 */
.merida  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.merida  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.merida  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.merida  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.merida  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.merida  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.merida  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.merida  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.merida  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.merida  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.merida  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.merida  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

/* Wikipedia */
.wikipedia  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.wikipedia  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.wikipedia  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.wikipedia  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.wikipedia  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.wikipedia cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.wikipedia cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.wikipedia cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.wikipedia cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.wikipedia cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.wikipedia cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.wikipedia cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
/* Alpha */
.alpha cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.alpha cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.alpha cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.alpha cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.alpha cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}
.alpha cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.alpha cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.alpha cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.alpha  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.alpha  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.alpha  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.alpha  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}
/* Beyer */
.beyer  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}
.beyer  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}
.beyer  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}
.beyer  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}
.beyer  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
.beyer  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
.beyer  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
.beyer  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
.beyer  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
.beyer  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
.beyer  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}
.beyer  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}
/* Case */
.case  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}
.case  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
.case  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}
.case  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}
.case  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}
.case  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}
.case  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}
.case  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}
.case  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}
.case  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}
.case  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}
.case  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}

/* Condal */
.condal  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
}
.condal  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
}
.condal  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
}
.condal  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
}
.condal  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
}
.condal  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
}
.condal  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
}
.condal  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
}
.condal  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
}
.condal  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
}
.condal  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
}
.condal  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
}
/* Leipzig */
.leipzig  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
}
.leipzig  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
}
.leipzig  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
}
.leipzig  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
}
.leipzig  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
}
.leipzig  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
}
.leipzig  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
}
.leipzig  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
}
.leipzig  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
}
.leipzig  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
}
.leipzig  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
}
.leipzig  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
}
/* Maya */
.maya  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
}
.maya  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
}
.maya  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
}
.maya  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
}
.maya  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
}
.maya  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}
.maya  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
}
.maya  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
}
.maya  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
}
.maya  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
}
.maya  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
}
.maya  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
}
/* USCF */
.uscf  cg-board piece.pawn.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
}
.uscf  cg-board piece.bishop.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
}
.uscf  cg-board piece.knight.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}
.uscf  cg-board piece.rook.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}
.uscf  cg-board piece.queen.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}
.uscf  cg-board piece.king.white {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
}
.uscf  cg-board piece.pawn.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
}
.uscf  cg-board piece.bishop.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
}
.uscf  cg-board piece.knight.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}
.uscf  cg-board piece.rook.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}
.uscf  cg-board piece.queen.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
}
.uscf  cg-board piece.king.black {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
}
`, "",{"version":3,"sources":["webpack://./src/css/theme.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2DAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,2DAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,2DAA6C;AAC/C;AACA;EACE,qBAAqB;EACrB,2DAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,2DAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,2DAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;;;AAIA;;EAEE;AACF;EACE,yDAA4C;AAC9C;AACA;EACE,yDAA6C;AAC/C;AACA;EACE,yDAA4C;AAC9C;AACA;EACE,yDAAkD;AACpD;AACA;EACE,0DAAmD;AACrD;AACA;EACE,0DAA6C;AAC/C;AACA;EACE,0DAA8C;AAChD;AACA;EACE,0DAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;;EAEE;AACF;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;;AAEA,cAAc;AACd;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA;EACE,0DAA4D;AAC9D;AACA,UAAU;AACV;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA,UAAU;AACV;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA;EACE,0DAAwD;AAC1D;AACA,SAAS;AACT;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;;AAEA,WAAW;AACX;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA;EACE,0DAAyD;AAC3D;AACA,YAAY;AACZ;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA,SAAS;AACT;EACE,0DAAuD;AACzD;AACA;EACE,0DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA,SAAS;AACT;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD;AACA;EACE,2DAAuD;AACzD","sourcesContent":["@font-face {\n  font-family: Alpha;\n  src: url('./ChessAlpha.woff') format(\"woff\");\n}\n@font-face {\n  font-family: Merida;\n  src: url('./ChessMerida.woff') format(\"woff\");\n}\n@font-face {\n  font-family: Berlin;\n  src: url('./ChessBerlin.woff') format(\"woff\");\n}\n@font-face {\n  font-family: NotoSans;\n  src: url('./NotoSans.woff') format(\"woff\");\n}\n@font-face {\n  font-family: \"CAChess\";\n  src: url('./CAChess-min.woff') format(\"woff\");\n}\n@font-face {\n  font-family: \"CAChessFig\";\n  src: url('./CAChess-fig.woff') format(\"woff\");\n}\n\nmove fig.figurine {\n  font-family: Alpha;\n}\nmove fig.figurine.merida {\n  font-family: Merida;\n}\nmove fig.figurine.berlin {\n  font-family: Berlin;\n}\nmove fig.figurine.noto {\n  font-family: NotoSans;\n}\nmove fig.figurine.cachess {\n  font-family: CAChessFig;\n}\n\nmove san nag {\n  font-family: CAChess;\n}\n\n/* Don't show diagram nags in the notation. */\n.pgnvjs .moves move  nag[data-value=\"$220\"]::before {\n  content: \"\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$221\"]::before {\n  content: \"\";\n}\n\n/* CA Chess Font symbols */\n.pgnvjs .moves move  nag[data-value=\"$246\"]::before {\n  content: \"\\00A8\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$247\"]::before {\n  content: \"\\00AE\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$248\"]::before {\n  content: \"\\00AF\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$252\"]::before {\n  content: \"\\045B\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$254\"]::before {\n  content: \"\\00AA\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$255\"]::before {\n  content: \"\\0454\";\n}\n\n/* Additional CA Chess Font symbols (drawn myself) */\n.pgnvjs .moves move  nag[data-value=\"$251\"]::before {\n  content: \"\\00DE\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$249\"]::before {\n  content: \"\\00DF\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$250\"]::before {\n  content: \"\\00E0\";\n}\n\n.pgnvjs .moves move  nag[data-value=\"$253\"]::before {\n  content: \"\\00E1\";\n}\n.pgnvjs .moves move  nag[data-value=\"$254\"]::before {\n  content: \"\\00AA\";\n}\n.pgnvjs .moves move  nag[data-value=\"$255\"]::before {\n  content: \"\\00BA\";\n}\n\n\n\n/*\n * Board\n */\n.blue cg-board {\n  background-image: url(../img/board/blue.svg);\n}\n.brown cg-board {\n  background-image: url(../img/board/brown.svg);\n}\n.zeit cg-board {\n  background-image: url(../img/board/zeit.svg);\n}\n.informator cg-board {\n  background-image: url(../img/board/informator.svg);\n}\n.sportverlag cg-board {\n  background-image: url(../img/board/sportverlag.svg);\n}\n.beyer cg-board {\n  background-image: url(../img/board/beyer.svg);\n}\n.falken cg-board {\n  background-image: url(../img/board/falken.svg);\n}\n.green cg-board {\n  background-image: url(../img/board/green.svg);\n}\n\n/* SWAL buttons */\n.modaly-wrapper {\n  top: unset;\n  left: unset;\n}\n.swalpgnvroot {\n  z-index: 1060;\n}\n.swalpgnv {\n  display: block;\n  width: 44px;\n  height: 44px;\n  background-size: 40px;\n}\n.swalpgnv.queen {\n  background-image: url('../img/chesspieces/merida/wQ.svg');\n}\n.swalpgnv.rook {\n  background-image: url('../img/chesspieces/merida/wR.svg');\n}\n.swalpgnv.bishop {\n  background-image: url('../img/chesspieces/merida/wB.svg');\n}\n.swalpgnv.knight {\n  background-image: url('../img/chesspieces/merida/wN.svg');\n}\n.swalpgnv.queen.black {\n  background-image: url('../img/chesspieces/merida/bQ.svg');\n}\n.swalpgnv.rook.black {\n  background-image: url('../img/chesspieces/merida/bR.svg');\n}\n.swalpgnv.bishop.black {\n  background-image: url('../img/chesspieces/merida/bB.svg');\n}\n.swalpgnv.knight.black {\n  background-image: url('../img/chesspieces/merida/bN.svg');\n}\n/*\n * Merida\n */\n.merida  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/merida/wP.svg');\n}\n.merida  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/merida/wB.svg');\n}\n.merida  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/merida/wN.svg');\n}\n.merida  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/merida/wR.svg');\n}\n.merida  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/merida/wQ.svg');\n}\n.merida  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/merida/wK.svg');\n}\n.merida  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/merida/bP.svg');\n}\n.merida  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/merida/bB.svg');\n}\n.merida  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/merida/bN.svg');\n}\n.merida  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/merida/bR.svg');\n}\n.merida  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/merida/bQ.svg');\n}\n.merida  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/merida/bK.svg');\n}\n\n/* Wikipedia */\n.wikipedia  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/wikipedia/wP.svg');\n}\n.wikipedia  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/wikipedia/wB.svg');\n}\n.wikipedia  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/wikipedia/wN.svg');\n}\n.wikipedia  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/wikipedia/wR.svg');\n}\n.wikipedia  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/wikipedia/wQ.svg');\n}\n.wikipedia cg-board piece.king.white {\n  background-image: url('../img/chesspieces/wikipedia/wK.svg');\n}\n.wikipedia cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/wikipedia/bP.svg');\n}\n.wikipedia cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/wikipedia/bB.svg');\n}\n.wikipedia cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/wikipedia/bN.svg');\n}\n.wikipedia cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/wikipedia/bR.svg');\n}\n.wikipedia cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/wikipedia/bQ.svg');\n}\n.wikipedia cg-board piece.king.black {\n  background-image: url('../img/chesspieces/wikipedia/bK.svg');\n}\n/* Alpha */\n.alpha cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/alpha/wP.svg');\n}\n.alpha cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/alpha/wB.svg');\n}\n.alpha cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/alpha/wN.svg');\n}\n.alpha cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/alpha/wR.svg');\n}\n.alpha cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/alpha/wQ.svg');\n}\n.alpha cg-board piece.king.white {\n  background-image: url('../img/chesspieces/alpha/wK.svg');\n}\n.alpha cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/alpha/bP.svg');\n}\n.alpha cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/alpha/bB.svg');\n}\n.alpha  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/alpha/bN.svg');\n}\n.alpha  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/alpha/bR.svg');\n}\n.alpha  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/alpha/bQ.svg');\n}\n.alpha  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/alpha/bK.svg');\n}\n/* Beyer */\n.beyer  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/beyer/wP.png');\n}\n.beyer  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/beyer/wB.png');\n}\n.beyer  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/beyer/wN.png');\n}\n.beyer  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/beyer/wR.png');\n}\n.beyer  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/beyer/wQ.png');\n}\n.beyer  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/beyer/wK.png');\n}\n.beyer  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/beyer/bP.png');\n}\n.beyer  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/beyer/bB.png');\n}\n.beyer  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/beyer/bN.png');\n}\n.beyer  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/beyer/bR.png');\n}\n.beyer  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/beyer/bQ.png');\n}\n.beyer  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/beyer/bK.png');\n}\n/* Case */\n.case  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/case/wP.svg');\n}\n.case  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/case/wB.svg');\n}\n.case  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/case/wN.svg');\n}\n.case  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/case/wR.svg');\n}\n.case  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/case/wQ.svg');\n}\n.case  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/case/wK.svg');\n}\n.case  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/case/bP.svg');\n}\n.case  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/case/bB.svg');\n}\n.case  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/case/bN.svg');\n}\n.case  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/case/bR.svg');\n}\n.case  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/case/bQ.svg');\n}\n.case  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/case/bK.svg');\n}\n\n/* Condal */\n.condal  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/condal/wP.png');\n}\n.condal  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/condal/wB.png');\n}\n.condal  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/condal/wN.png');\n}\n.condal  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/condal/wR.png');\n}\n.condal  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/condal/wQ.png');\n}\n.condal  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/condal/wK.png');\n}\n.condal  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/condal/bP.png');\n}\n.condal  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/condal/bB.png');\n}\n.condal  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/condal/bN.png');\n}\n.condal  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/condal/bR.png');\n}\n.condal  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/condal/bQ.png');\n}\n.condal  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/condal/bK.png');\n}\n/* Leipzig */\n.leipzig  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/leipzig/wP.svg');\n}\n.leipzig  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/leipzig/wB.svg');\n}\n.leipzig  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/leipzig/wN.svg');\n}\n.leipzig  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/leipzig/wR.svg');\n}\n.leipzig  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/leipzig/wQ.svg');\n}\n.leipzig  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/leipzig/wK.svg');\n}\n.leipzig  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/leipzig/bP.svg');\n}\n.leipzig  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/leipzig/bB.svg');\n}\n.leipzig  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/leipzig/bN.svg');\n}\n.leipzig  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/leipzig/bR.svg');\n}\n.leipzig  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/leipzig/bQ.svg');\n}\n.leipzig  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/leipzig/bK.svg');\n}\n/* Maya */\n.maya  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/maya/wP.svg');\n}\n.maya  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/maya/wB.svg');\n}\n.maya  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/maya/wN.svg');\n}\n.maya  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/maya/wR.svg');\n}\n.maya  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/maya/wQ.svg');\n}\n.maya  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/maya/wK.svg');\n}\n.maya  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/maya/bP.svg');\n}\n.maya  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/maya/bB.svg');\n}\n.maya  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/maya/bN.svg');\n}\n.maya  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/maya/bR.svg');\n}\n.maya  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/maya/bQ.svg');\n}\n.maya  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/maya/bK.svg');\n}\n/* USCF */\n.uscf  cg-board piece.pawn.white {\n  background-image: url('../img/chesspieces/uscf/wP.png');\n}\n.uscf  cg-board piece.bishop.white {\n  background-image: url('../img/chesspieces/uscf/wB.png');\n}\n.uscf  cg-board piece.knight.white {\n  background-image: url('../img/chesspieces/uscf/wN.png');\n}\n.uscf  cg-board piece.rook.white {\n  background-image: url('../img/chesspieces/uscf/wR.png');\n}\n.uscf  cg-board piece.queen.white {\n  background-image: url('../img/chesspieces/uscf/wQ.png');\n}\n.uscf  cg-board piece.king.white {\n  background-image: url('../img/chesspieces/uscf/wK.png');\n}\n.uscf  cg-board piece.pawn.black {\n  background-image: url('../img/chesspieces/uscf/bP.png');\n}\n.uscf  cg-board piece.bishop.black {\n  background-image: url('../img/chesspieces/uscf/bB.png');\n}\n.uscf  cg-board piece.knight.black {\n  background-image: url('../img/chesspieces/uscf/bN.png');\n}\n.uscf  cg-board piece.rook.black {\n  background-image: url('../img/chesspieces/uscf/bR.png');\n}\n.uscf  cg-board piece.queen.black {\n  background-image: url('../img/chesspieces/uscf/bQ.png');\n}\n.uscf  cg-board piece.king.black {\n  background-image: url('../img/chesspieces/uscf/bK.png');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
